import { render } from "./AdminUserGamesElement.vue?vue&type=template&id=7f6c86dd&scoped=true"
import script from "./AdminUserGamesElement.vue?vue&type=script&lang=js"
export * from "./AdminUserGamesElement.vue?vue&type=script&lang=js"

import "./AdminUserGamesElement.vue?vue&type=style&index=0&id=7f6c86dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6c86dd"]])

export default __exports__